import { useEffect, useState } from 'react';

/**
 * Debounce a value; updates after `delayMs` of no changes.
 * Empty/nullish values flush immediately so search resets don't fire stale queries.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  const empty = value === '' || value === null || value === undefined;
  if (empty && !Object.is(debounced, value)) setDebounced(value);

  useEffect(() => {
    if (empty) return;
    const id = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(id);
  }, [empty, value, delayMs]);

  return debounced;
}
